"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORIGIN = exports.COORDINATE_DELTAS = exports.CoordinateUtils = exports.CoordinateCodec = void 0;
const Direction_1 = require("./Direction");
const t = __importStar(require("io-ts"));
const CoordinateCodec = t.type({
    x: t.number,
    y: t.number,
});
exports.CoordinateCodec = CoordinateCodec;
const CoordinateUtils = {
    isEqual(coord1, coord2) {
        return coord1.x === coord2.x && coord1.y === coord2.y;
    },
    negate(coord) {
        return { x: -1 * coord.x, y: -1 * coord.y };
    },
    add(coord1, coord2) {
        return {
            x: coord1.x + coord2.x,
            y: coord1.y + coord2.y,
        };
    },
    subtract(coord1, coord2) {
        return this.add(coord1, this.negate(coord2));
    },
    floor(coord) {
        return {
            x: Math.floor(coord.x),
            y: Math.floor(coord.y),
        };
    },
    ceil(coord) {
        return {
            x: Math.ceil(coord.x),
            y: Math.ceil(coord.y),
        };
    },
    round(coord) {
        return {
            x: Math.round(coord.x),
            y: Math.round(coord.y),
        };
    },
    scale(coord, factor) {
        return {
            x: coord.x * factor,
            y: coord.y * factor,
        };
    },
};
exports.CoordinateUtils = CoordinateUtils;
const COORDINATE_DELTAS = {
    [Direction_1.Direction.UP]: { x: 0, y: -1 },
    [Direction_1.Direction.LEFT]: { x: -1, y: 0 },
    [Direction_1.Direction.RIGHT]: { x: 1, y: 0 },
    [Direction_1.Direction.DOWN]: { x: 0, y: 1 },
};
exports.COORDINATE_DELTAS = COORDINATE_DELTAS;
const ORIGIN = { x: 0, y: 0 };
exports.ORIGIN = ORIGIN;
//# sourceMappingURL=Coordinate.js.map